import * as React from 'react';
import {
  Box,
  Image,
  ParagraphText,
  TextAction,
} from '@leagueplatform/genesis-core';
import { SidebarLayout } from '@leagueplatform/genesis-core-alpha';
import { InternalOrExternalLink as Link } from '@leagueplatform/web-common-components';
import type { DefaultCoverageCardProps } from '#types/coverage-detail-widget-cards.types.ts';

type DefaultCardProps = DefaultCoverageCardProps;

export function DefaultCard({
  ctaIndicator,
  ctaLabel,
  ctaId,
  ctaLabelledbyId,
  description,
  href,
  image,
  onClick: handleOnClick,
}: DefaultCardProps) {
  const isLink = !!href;
  const indicator = React.useMemo(() => {
    // Genesis Core TextAction expects the chevron to be 'disclosure'
    // We want to fallback for defaultCard to show a chevron.
    if (!ctaIndicator || ctaIndicator === 'chevron') {
      return 'disclosure';
    }
    return ctaIndicator;
  }, [ctaIndicator]);

  if (!image?.url && !description && !ctaLabel) {
    return null;
  }

  return (
    <SidebarLayout
      css={{ width: '100%', alignItems: 'center' }}
      spacing="$oneAndHalf"
      sidebarSide="leading"
      sidebarSize="lg"
    >
      {image?.url && (
        <Box>
          <Image
            src={image.url}
            alt={image.description ?? ''}
            css={{ maxWidth: '100%' }}
          />
        </Box>
      )}
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '$one' }}>
        {description && <ParagraphText>{description}</ParagraphText>}
        {ctaLabel && (
          <TextAction
            as="button"
            indicator={indicator}
            size="large"
            css={{ width: 'fit-content' }}
            aria-labelledby={ctaLabelledbyId}
            id={ctaId}
            onClick={handleOnClick}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...(isLink && {
              as: Link,
              href,
            })}
          >
            {ctaLabel}
          </TextAction>
        )}
      </Box>
    </SidebarLayout>
  );
}
